import { Box, Link, Typography } from '@mui/material'
import { color } from 'config/color'
import type React from 'react'


export const LoginBanner: React.FC = () => {
    return (
        <Box bgcolor={color.background[900]} py={3} color={color.white} borderRadius={0} textAlign="center" fontSize={17}>
            <Typography margin="auto" width="75%">
                First-time registering? Your Del-Co account number has changed as of 2/24/2025.  If you have a bill printed before then, it still shows your old account number. <br />
                You can find your new account number by checking your inbox for an email from <Link color={color.white} href="mailto:no-reply-billing@delcowater.org">no-reply-billing@delcowater.org</Link> to find it.
            </Typography>
        </Box>

    )
}
